import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bookmumbaitooutstationcab() {



    const cardData = {
"keyword": "Book Mumbai to Outstation Cab Service",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Book Mumbai to Outstation Cab Service for travelers looking for safe, affordable, and convenient long-distance travel solutions from Mumbai to various destinations across Maharashtra and India. Whether you are planning a family vacation, weekend getaway, pilgrimage tour, business trip, wedding travel, corporate journey, or group outing, our outstation cab service ensures a smooth and stress-free travel experience. With experienced drivers familiar with highways, expressways, ghat sections, and intercity travel routes, clean air-conditioned vehicles maintained for maximum comfort, and transparent pricing with no hidden charges, we provide a dependable outstation travel solution for every passenger. Our fleet includes sedans, SUVs, Innova cars, Ertiga vehicles, tempo travellers, and premium cars suitable for solo travelers, families, corporate clients, and large groups seeking comfortable long-distance transportation from Mumbai.",

"topPlaces": [
  {
    "title": "Lonavala",
    "description":
      "Lonavala is one of the most popular hill stations near Mumbai known for scenic valleys, waterfalls, green mountains, forts, caves, and pleasant weather throughout the year. Tourists frequently visit Lonavala for weekend getaways, monsoon trips, trekking experiences, and relaxing holidays surrounded by the beauty of the Sahyadri hills."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station in Maharashtra known for strawberry farms, lush greenery, cool climate, beautiful viewpoints, lakes, and waterfalls. Visitors enjoy boating at Venna Lake, sightseeing at Arthur’s Seat, exploring local markets, and experiencing peaceful nature-filled vacations."
  },
  {
    "title": "Goa",
    "description":
      "Goa is India’s most famous beach destination known for sandy beaches, nightlife, water sports, Portuguese heritage, beach shacks, churches, and vibrant tourist culture. Travelers from Mumbai often choose Goa for family vacations, honeymoon trips, friends getaways, adventure sports, and relaxing coastal holidays."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is one of India’s major pilgrimage destinations and home to the revered Sai Baba Temple visited by millions of devotees every year. The town is known for its spiritual atmosphere, temple complexes, religious ceremonies, and peaceful environment attracting visitors from across the country."
  },
  {
    "title": "Pune",
    "description":
      "Pune is a major cultural, educational, and business city in Maharashtra known for historical landmarks, modern lifestyle, forts, temples, shopping areas, and nearby hill stations. Travelers frequently visit Pune for business meetings, educational purposes, family visits, and tourism activities."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is a spiritually and culturally important city famous for Trimbakeshwar Temple, vineyards, wine tourism, river ghats, and Kumbh Mela celebrations. The destination attracts pilgrims, wine lovers, nature enthusiasts, and tourists looking for a peaceful getaway from Mumbai."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a beautiful coastal destination near Mumbai known for beaches, sea forts, coconut trees, water sports, and relaxing weekend experiences. Tourists visit Alibaug for beach holidays, family outings, camping experiences, and short scenic road trips from Mumbai."
  },
  {
    "title": "Aurangabad",
    "description":
      "Aurangabad is a historically significant city famous for the UNESCO World Heritage Ajanta and Ellora Caves featuring ancient rock-cut architecture and sculptures. The city also offers historical monuments, Mughal heritage sites, and cultural attractions attracting domestic and international tourists."
  },
  {
    "title": "Matheran",
    "description":
      "Matheran is a peaceful eco-friendly hill station near Mumbai known for vehicle-free roads, toy train rides, scenic viewpoints, horse riding, and cool mountain climate. It is a popular destination for nature lovers, couples, photographers, and families seeking a relaxing break from city life."
  },
  {
    "title": "Igatpuri",
    "description":
      "Igatpuri is a scenic hill station surrounded by mountains, waterfalls, forests, and misty valleys in the Western Ghats. The destination is famous for trekking, monsoon tourism, meditation centers, camping experiences, and breathtaking natural beauty attracting adventure and nature enthusiasts."
  }
],



services: [
  {
    name: "Mumbai to Jaipur Cab",
    description: "Mumbai to Jaipur cab service provides reliable transportation for travelers planning long-distance road journeys between Mumbai and Jaipur. Vehicles ensure smooth highway travel suitable for tourism trips, heritage tours, family vacations, and executive travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Jaipur cab reservations."
  },
  {
    name: "Mumbai to Udaipur Cab",
    description: "Mumbai to Udaipur cab service offers comfortable transportation for travelers planning scenic road journeys to Udaipur. Vehicles ensure reliable highway travel suitable for tourism travel, honeymoon trips, family holidays, and sightseeing tours. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Udaipur cab reservations."
  },
  {
    name: "Mumbai to Jodhpur Cab",
    description: "Mumbai to Jodhpur cab service provides dependable transportation for travelers planning smooth intercity road journeys to Rajasthan. Vehicles ensure comfortable highway travel suitable for tourism trips, cultural tours, family vacations, and executive journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Jodhpur cab reservations."
  },
  {
    name: "Mumbai to Mount Abu Cab",
    description: "Mumbai to Mount Abu cab service provides reliable transportation for travelers planning hill station road journeys from Mumbai. Vehicles ensure smooth highway and ghat travel suitable for tourism travel, sightseeing tours, family holidays, and weekend getaways. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Mount Abu cab reservations."
  },
  {
    name: "Mumbai to Ajmer Cab",
    description: "Mumbai to Ajmer cab service offers dependable transportation for travelers planning comfortable road journeys to Ajmer. Vehicles ensure reliable highway travel suitable for pilgrimage travel, tourism trips, family vacations, and sightseeing tours. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Ajmer cab reservations."
  },
  {
    name: "Mumbai to Indore Cab",
    description: "Mumbai to Indore cab service provides reliable transportation for travelers planning smooth intercity road journeys between Mumbai and Indore. Vehicles ensure comfortable highway travel suitable for business travel, tourism trips, family holidays, and executive journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Indore cab reservations."
  },
  {
    name: "Mumbai to Ujjain Cab",
    description: "Mumbai to Ujjain cab service provides dependable transportation for travelers planning pilgrimage and tourism road journeys to Ujjain. Vehicles ensure smooth highway travel suitable for temple visits, family vacations, religious tours, and sightseeing trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Ujjain cab reservations."
  },
  {
    name: "Mumbai to Bhopal Cab",
    description: "Mumbai to Bhopal cab service offers comfortable transportation for travelers planning long-distance road journeys between Mumbai and Bhopal. Vehicles ensure reliable highway travel suitable for tourism travel, business trips, family holidays, and executive travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Bhopal cab reservations."
  },
  {
    name: "Mumbai to Omkareshwar Cab",
    description: "Mumbai to Omkareshwar cab service provides reliable transportation for travelers planning pilgrimage road journeys to Omkareshwar Jyotirlinga. Vehicles ensure smooth highway travel suitable for temple visits, religious travel, family outings, and sightseeing tours. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Omkareshwar cab reservations."
  },
  {
    name: "Mumbai to Gwalior Cab",
    description: "Mumbai to Gwalior cab service provides dependable transportation for travelers planning comfortable intercity road journeys to Gwalior. Vehicles ensure reliable highway travel suitable for tourism trips, heritage tours, family vacations, and executive travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Gwalior cab reservations."
  },
  {
    name: "Mumbai to Delhi Cab",
    description: "Mumbai to Delhi cab service provides reliable long-distance transportation for travelers planning smooth road journeys between Mumbai and Delhi. Vehicles ensure comfortable highway travel suitable for executive travel, tourism trips, family vacations, and corporate journeys. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Delhi cab reservations."
  },
  {
    name: "Mumbai to Gurgaon Cab",
    description: "Mumbai to Gurgaon cab service offers dependable transportation for travelers planning comfortable intercity road journeys to Gurgaon. Vehicles ensure smooth highway travel suitable for executive trips, business travel, tourism travel, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Gurgaon cab reservations."
  },
  {
    name: "Mumbai to Noida Cab",
    description: "Mumbai to Noida cab service provides reliable transportation for travelers planning long-distance road journeys to Noida. Vehicles ensure dependable highway travel suitable for executive travel, tourism trips, family holidays, and corporate journeys. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Noida cab reservations."
  },
  {
    name: "Mumbai to Faridabad Cab",
    description: "Mumbai to Faridabad cab service provides comfortable transportation for travelers planning smooth intercity road journeys to Faridabad. Vehicles ensure reliable highway travel suitable for business travel, tourism trips, family vacations, and executive journeys. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Faridabad cab reservations."
  },
  {
    name: "Mumbai to Delhi NCR Taxi",
    description: "Mumbai to Delhi NCR taxi service offers dependable transportation for travelers planning comfortable long-distance road journeys to Delhi NCR region. Vehicles ensure smooth highway travel suitable for business travel, tourism travel, family vacations, and executive journeys. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Delhi NCR taxi reservations."
  },
  {
    name: "Mumbai to Agra Cab",
    description: "Mumbai to Agra cab service provides reliable transportation for travelers planning heritage and tourism road journeys to Agra. Vehicles ensure comfortable highway travel suitable for sightseeing tours, family holidays, tourism trips, and executive travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Agra cab reservations."
  },
  {
    name: "Mumbai to Varanasi Cab",
    description: "Mumbai to Varanasi cab service offers dependable transportation for travelers planning pilgrimage and tourism road journeys to Varanasi. Vehicles ensure smooth highway travel suitable for temple visits, religious tours, family vacations, and sightseeing trips. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Varanasi cab reservations."
  },
  {
    name: "Mumbai to Lucknow Cab",
    description: "Mumbai to Lucknow cab service provides reliable transportation for travelers planning comfortable intercity road journeys to Lucknow. Vehicles ensure dependable highway travel suitable for executive travel, tourism trips, family holidays, and business travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Lucknow cab reservations."
  },
  {
    name: "Mumbai to Prayagraj Cab",
    description: "Mumbai to Prayagraj cab service provides dependable transportation for travelers planning pilgrimage and tourism road journeys to Prayagraj. Vehicles ensure reliable highway travel suitable for religious travel, family vacations, sightseeing tours, and tourism trips. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Prayagraj cab reservations."
  },
  {
    name: "Mumbai to Ayodhya Cab",
    description: "Mumbai to Ayodhya cab service offers reliable transportation for travelers planning pilgrimage road journeys to Ayodhya. Vehicles ensure smooth highway travel suitable for temple visits, family holidays, tourism travel, and religious tours. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Ayodhya cab reservations."
  },
  {
    name: "Mumbai to Amritsar Cab",
    description: "Mumbai to Amritsar cab service provides dependable transportation for travelers planning long-distance pilgrimage and tourism road journeys. Vehicles ensure comfortable highway travel suitable for religious tours, family vacations, sightseeing trips, and executive journeys. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Amritsar cab reservations."
  },
  {
    name: "Mumbai to Chandigarh Cab",
    description: "Mumbai to Chandigarh cab service offers reliable transportation for travelers planning smooth intercity road journeys to Chandigarh. Vehicles ensure dependable highway travel suitable for executive travel, tourism trips, family holidays, and corporate travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Chandigarh cab reservations."
  },
  {
    name: "Mumbai to Ludhiana Cab",
    description: "Mumbai to Ludhiana cab service provides dependable transportation for travelers planning comfortable long-distance road journeys to Ludhiana. Vehicles ensure smooth highway travel suitable for business travel, tourism trips, family vacations, and executive journeys. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Ludhiana cab reservations."
  },
  {
    name: "Mumbai to Jalandhar Cab",
    description: "Mumbai to Jalandhar cab service offers reliable transportation for travelers planning smooth intercity road journeys to Jalandhar. Vehicles ensure reliable highway travel suitable for tourism trips, family holidays, executive travel, and business journeys. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Jalandhar cab reservations."
  },
  {
    name: "Mumbai to Patiala Cab",
    description: "Mumbai to Patiala cab service provides dependable transportation for travelers planning comfortable road journeys to Patiala. Vehicles ensure smooth highway travel suitable for tourism travel, family vacations, executive journeys, and business travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Patiala cab reservations."
  },
  {
    name: "Mumbai to Dehradun Cab",
    description: "Mumbai to Dehradun cab service offers reliable transportation for travelers planning scenic road journeys to Dehradun. Vehicles ensure dependable highway and hill-route travel suitable for tourism trips, family holidays, sightseeing tours, and executive travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Dehradun cab reservations."
  },
  {
    name: "Mumbai to Haridwar Cab",
    description: "Mumbai to Haridwar cab service provides dependable transportation for travelers planning pilgrimage and tourism road journeys to Haridwar. Vehicles ensure smooth highway travel suitable for religious travel, temple visits, family vacations, and sightseeing trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Haridwar cab reservations."
  },
  {
    name: "Mumbai to Rishikesh Cab",
    description: "Mumbai to Rishikesh cab service offers reliable transportation for travelers planning scenic and spiritual road journeys to Rishikesh. Vehicles ensure comfortable highway and hill-route travel suitable for tourism trips, yoga retreats, family holidays, and sightseeing tours. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Rishikesh cab reservations."
  },
  {
    name: "Mumbai to Nainital Cab",
    description: "Mumbai to Nainital cab service provides comfortable transportation for travelers planning hill station road journeys to Nainital. Vehicles ensure reliable highway and mountain travel suitable for tourism trips, family vacations, sightseeing tours, and honeymoon travel. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Nainital cab reservations."
  }
],

tableData: [
  ["Mumbai to Jaipur Cab", "Mumbai to Udaipur Cab"],
  ["Mumbai to Jodhpur Cab", "Mumbai to Mount Abu Cab"],
  ["Mumbai to Ajmer Cab", "Mumbai to Indore Cab"],
  ["Mumbai to Ujjain Cab", "Mumbai to Bhopal Cab"],
  ["Mumbai to Omkareshwar Cab", "Mumbai to Gwalior Cab"],
  ["Mumbai to Delhi Cab", "Mumbai to Gurgaon Cab"],
  ["Mumbai to Noida Cab", "Mumbai to Faridabad Cab"],
  ["Mumbai to Delhi NCR Taxi", "Mumbai to Agra Cab"],
  ["Mumbai to Varanasi Cab", "Mumbai to Lucknow Cab"],
  ["Mumbai to Prayagraj Cab", "Mumbai to Ayodhya Cab"],
  ["Mumbai to Amritsar Cab", "Mumbai to Chandigarh Cab"],
  ["Mumbai to Ludhiana Cab", "Mumbai to Jalandhar Cab"],
  ["Mumbai to Patiala Cab", "Mumbai to Dehradun Cab"],
  ["Mumbai to Haridwar Cab", "Mumbai to Rishikesh Cab"],
  ["Mumbai to Nainital Cab", "Mumbai to Jaipur Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai Outstation Cab Booking Service",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Mumbai outstation cab booking service with professional drivers, comfortable vehicles, and smooth long-distance travel for families, tourists, and corporate travelers."
  },
  {
    WhyChooseheading: "Affordable Mumbai Outstation Taxi Fare",
    WhyChoosedescription: "Our Mumbai outstation taxi service offers affordable pricing with transparent fare details and no hidden charges for one-way and round-trip travel bookings."
  },
  {
    WhyChooseheading: "24/7 Mumbai Outstation Cab Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Mumbai outstation cab bookings including airport transfers, holiday trips, business travel, family vacations, and emergency journeys."
  },
  {
    WhyChooseheading: "Comfortable AC Cabs for Long Distance Travel",
    WhyChoosedescription: "All Mumbai outstation taxis are fully air-conditioned, sanitized, spacious, and regularly maintained for smooth and comfortable highway travel experiences."
  },
  {
    WhyChooseheading: "One Way & Round Trip Outstation Taxi Booking",
    WhyChoosedescription: "Customers can book one-way Mumbai outstation cabs, round-trip taxi services, return travel options, and customized outstation tour packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Choices",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, luxury vehicles, and Tempo Travellers suitable for solo travelers, families, tourists, and group tours."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup service from Mumbai Airport, Navi Mumbai, Thane, hotels, homes, railway stations, offices, and all major Mumbai locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Highway & Interstate Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Maharashtra highways, hill station routes, coastal roads, and interstate travel to ensure safe driving and timely arrival."
  }
]
};

const faqData = [
  {
    question: "What is Mumbai outstation cab booking service?",
    answer: "Mumbai outstation cab booking service provides comfortable taxi transportation from Mumbai to nearby cities, tourist destinations, hill stations, and interstate locations."
  },
  {
    question: "Is Mumbai outstation cab service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Mumbai outstation taxi service."
  },
  {
    question: "Which vehicles are available for Mumbai outstation travel?",
    answer: "Customers can choose sedan taxis, Ertiga, Innova, Innova Crysta, SUVs, luxury cars, and Tempo Travellers."
  },
  {
    question: "Can I book one-way and round-trip outstation cabs from Mumbai?",
    answer: "Yes, one-way as well as round-trip Mumbai outstation cab bookings are available."
  },
  {
    question: "Do you provide Mumbai Airport pickup for outstation travel?",
    answer: "Yes, Om Sai Cab Service provides airport pickup and drop service for outstation taxi travel."
  },
  {
    question: "Are all Mumbai outstation taxis air-conditioned?",
    answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel."
  },
  {
    question: "Can I book Mumbai outstation cab service online?",
    answer: "Yes, customers can easily book Mumbai outstation cab service online or through phone booking."
  },
  {
    question: "Which destinations are covered under Mumbai outstation taxi service?",
    answer: "Popular destinations include Pune, Goa, Mahabaleshwar, Lonavala, Nashik, Shirdi, Kolhapur, Alibaug, and many more."
  },
  {
    question: "Are Mumbai outstation cab fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Mumbai outstation cabs?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prashant Deshmukh",
    feedback: "Booked Om Sai Cab Service for Mumbai to outstation travel and had a very reliable experience. The cab was comfortable, and the driver handled the long journey with great professionalism.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Kulkarni",
    feedback: "Our Mumbai to outstation cab booking with Om Sai Cab Service was excellent. The ride was smooth, the vehicle was clean, and the entire trip felt safe and well-organized.",
    rating: 5
  }
];












    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Outstation Cab Service",
  "image": "http://www.omsaicabservice.com/assets/images/mumbai-to-outstation-cab.jpg",
  "description": "Book Mumbai to outstation cab service with Om Sai Cab Service for long-distance travel across India. Affordable AC Sedan, SUV, Innova, and luxury taxis available for Jaipur, Udaipur, Jodhpur, Delhi NCR, Agra, Varanasi, Lucknow, and other major cities with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/mumbai-to-outstation-cab-service"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Mumbai to Outstation Cab Service | All India Taxi Booking | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Mumbai to outstation cab service for long-distance travel across India. Affordable taxi service available for Jaipur, Udaipur, Jodhpur, Delhi NCR, Agra, Varanasi, Lucknow, and more with Sedan, SUV, Innova, and luxury cabs."
  />

  <meta
    name="keywords"
    content="Mumbai to Jaipur Cab, Mumbai to Udaipur Cab, Mumbai to Jodhpur Cab, Mumbai to Mount Abu Cab, Mumbai to Ajmer Cab, Mumbai to Indore Cab, Mumbai to Ujjain Cab, Mumbai to Bhopal Cab, Mumbai to Omkareshwar Cab, Mumbai to Gwalior Cab, Mumbai to Delhi Cab, Mumbai to Gurgaon Cab, Mumbai to Noida Cab, Mumbai to Faridabad Cab, Mumbai to Delhi NCR Taxi, Mumbai to Agra Cab, Mumbai to Varanasi Cab, Mumbai to Lucknow Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bookmumbaitooutstationcab;